/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };



//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/babel-runtime/6.20.0/babel-runtime/core-js/object/create.js
// module id = 161
// module chunks = 0